import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import commonPropTypes from '../../../constants/commonPropTypes';
import MaskedInputField from '../maskedInputField';
import { createNumberMask } from '../../../utils/inputMasks';
import * as currency from '../../../utils/currency';
class BaseCurrencyInputField extends React.Component {
    static propTypes = {
        ...commonPropTypes,
        elmId: PropTypes.string.isRequired,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
        name: PropTypes.string.isRequired,
        compact: PropTypes.bool,
        allowDecimal: PropTypes.bool,
        maskOptions: PropTypes.object,
    };
    static defaultProps = {
        compact: false,
        allowDecimal: true,
        maskOptions: null,
    };
    render() {
        const { allowDecimal, maskOptions } = this.props;
        const mask = maskOptions
            ? createNumberMask(maskOptions)
            : allowDecimal
                ? currency.mask
                : currency.noDecimalMask;
        return (_jsx(MaskedInputField, { inputMode: 'numeric', mask: mask, normalizeOnBlur: allowDecimal ? currency.normalize : currency.normalizeNoDecimal, ...this.props }));
    }
}
export default BaseCurrencyInputField;
//# sourceMappingURL=index.js.map